import type { Trace, ApiResponse } from './types';
import { apiGet } from '../services/api';

export async function getTrace(id: string): Promise<Trace> {
  try {
    const res = await apiGet<ApiResponse<Trace>>(`/traces/${id}`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch trace');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function listTraces(taskId?: string): Promise<Trace[]> {
  try {
    const path = taskId
      ? `/traces?task_id=${encodeURIComponent(taskId)}`
      : '/traces';
    const res = await apiGet<ApiResponse<Trace[]>>(path);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch traces');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function getTraceWithSteps(id: string): Promise<Trace> {
  try {
    const res = await apiGet<ApiResponse<Trace>>(`/traces/${id}?include_steps=true`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch trace with steps');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}